import { sharedInitialValues } from '../shared/sharedInitialValues';

export const initialValues = (values = {}) => ({
    selectedMedications: [
        {
            title: '',
            variants: 'custom',
            selectedVariant: '',
        },
    ],
    lastVisitToDoctor: null,
    additionalDiseases: null,
    importantInformation: '',
    uploadedFile: [],
    ...sharedInitialValues(values),
});
